import type { ProductDetailFeaturesFragment } from '@shared/types/storefront/graphql'

export const toProductDetailFeatures = (
  productDetailFeatures: ProductDetailFeaturesFragment | undefined | null
) => {
  const mappedProductDetailFeatures =
    productDetailFeatures?.references?.nodes.map((node) => {
      if (!node || node.__typename !== 'Metaobject') {
        return null
      }

      return node.handle
    })

  if (!mappedProductDetailFeatures) {
    return []
  }

  return mappedProductDetailFeatures.filter(
    (mappedProductDetailFeature) => !!mappedProductDetailFeature
  ) as string[]
}
